import { createApp } from 'vue'
import axios from 'axios'
import { ENV, WEB_USERNAME, WEB_PASS, HOME_URL } from './constants/envrionment';
import List from './views/List.vue'

async function fetchData() {

    let axiosParams = {};

    if(ENV == 'dev'){
        axiosParams['headers'] ={
            authorization: "Basic " + btoa(WEB_USERNAME + ":" + WEB_PASS)
        }
    }

    const res = await axios.get(HOME_URL+'auctions/ajax/get_list', axiosParams);    

    if(res.data.status){
                    
        return res.data.data
    }

    return []
}

// Fetch data first, then initialize the app
fetchData().then((data) => {

    const app = createApp(List);

    // Make the fetched data globally available
    app.config.globalProperties.$auctionsData = data;

    app.mount('#auctionList')

}).catch((error) => {

    console.error('Failed to fetch initial data:', error);
    // Optionally handle fetch failure
});